// Import and register all your controllers
import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import all controllers
import AddCommentModalController from "./add_comment_modal_controller"
import AuditTrailModalController from "./audit_trail_modal_controller"
import ClipboardController from "./clipboard_controller"
import CommentsModalController from "./comments_modal_controller"
import DataCatalogRelationsModalController from "./data_catalog_relations_modal_controller"
import DependentSelectController from "./dependent_select_controller"
import DesignerController from "./designer_controller"
import DownloadDropdownController from "./download_dropdown_controller"
import DownloadAuditRefreshController from "./download_audit_refresh_controller"
import DropdownController from "./dropdown_controller"
import DisapprovalFormController from "./disapproval_form_controller"
import DrawerController from "./drawer_controller"
import DrawerTabsController from "./drawer_tabs_controller"
import DragController from "./drag_controller"
import EmployeeSalesOpportunityController from "./employee_sales_opportunity_controller"
import ExpectedHoursModalController from "./expected_hours_modal_controller"
import FileUploadController from "./file_upload_controller"
import FingerprintController from "./fingerprint_controller"
import FlashController from "./flash_controller"
import GroupSettingsController from "./group_settings_controller"
import HoursDaysToggleController from "./hours_days_toggle_controller"
import LoadingController from "./loading_controller"
import MainSidebarController from "./main_sidebar_controller"
import MobileNavController from "./mobile_nav_controller"
import MobileHomeRedirectController from "./mobile_home_redirect_controller"
import MatchingDashboardChartsController from "./matching_dashboard_charts_controller"
import MatchingRankingsExpandController from "./matching_rankings_expand_controller"
import MatchingRefreshPollController from "./matching_refresh_poll_controller"
import MatchingStatusReasonController from "./matching_status_reason_controller"
import MigratieController from "./migratie_controller"
import MobilityModalController from "./mobility_modal_controller"
import ModalController from "./modal_controller"
import PopoverController from "./popover_controller"
import ProjectInfoModalController from "./project_info_modal_controller"
import ProviderWebUrlsController from "./provider_web_urls_controller"
import ReportFormController from "./report_form_controller"
import SalaryCalculationPollController from "./salary_calculation_poll_controller"
import SalaryCalculationRegeneratePollController from "./salary_calculation_regenerate_poll_controller"
import SalaryImportPollController from "./salary_import_poll_controller"
import SalaryIndicatorsPaginationController from "./salary_indicators_pagination_controller"
import SalaryCoverageModalController from "./salary_coverage_modal_controller"
import ScraperLogsModalController from "./scraper_logs_modal_controller"
import SharedSecretFormController from "./shared_secret_form_controller"
import SidebarCollapseController from "./sidebar_collapse_controller"
import StrategicCustomerDetailsController from "./strategic_customer_details_controller"
import StrategicCustomerFiltersController from "./strategic_customer_filters_controller"
import StrategicCustomerMetricsTableController from "./strategic_customer_metrics_table_controller"
import StrategicCustomerTargetTotalController from "./strategic_customer_target_total_controller"
import ToggleController from "./toggle_controller"
import PayloadModalController from "./payload_modal_controller"
import ProcessLogModalController from "./process_log_modal_controller"
import ErrorToggleController from "./error_toggle_controller"

// Register controllers
application.register("add-comment-modal", AddCommentModalController)
application.register("audit-trail-modal", AuditTrailModalController)
application.register("clipboard", ClipboardController)
application.register("comments-modal", CommentsModalController)
application.register("data-catalog-relations-modal", DataCatalogRelationsModalController)
application.register("dependent-select", DependentSelectController)
application.register("designer", DesignerController)
application.register("download-dropdown", DownloadDropdownController)
application.register("download-audit-refresh", DownloadAuditRefreshController)
application.register("dropdown", DropdownController)
application.register("disapproval-form", DisapprovalFormController)
application.register("drawer", DrawerController)
application.register("drawer-tabs", DrawerTabsController)
application.register("drag", DragController)
application.register("employee-sales-opportunity", EmployeeSalesOpportunityController)
application.register("expected-hours-modal", ExpectedHoursModalController)
application.register("file-upload", FileUploadController)
application.register("fingerprint", FingerprintController)
application.register("flash", FlashController)
application.register("group-settings", GroupSettingsController)
application.register("hours-days-toggle", HoursDaysToggleController)
application.register("loading", LoadingController)
application.register("main-sidebar", MainSidebarController)
application.register("mobile-nav", MobileNavController)
application.register("mobile-home-redirect", MobileHomeRedirectController)
application.register("matching-dashboard-charts", MatchingDashboardChartsController)
application.register("matching-rankings-expand", MatchingRankingsExpandController)
application.register("matching-refresh-poll", MatchingRefreshPollController)
application.register("matching-status-reason", MatchingStatusReasonController)
application.register("migratie", MigratieController)
application.register("mobility-modal", MobilityModalController)
application.register("modal", ModalController)
application.register("project-info-modal", ProjectInfoModalController)
application.register("provider-web-urls", ProviderWebUrlsController)
application.register("popover", PopoverController)
application.register("report-form", ReportFormController)
application.register("salary-calculation-poll", SalaryCalculationPollController)
application.register("salary-calculation-regenerate-poll", SalaryCalculationRegeneratePollController)
application.register("salary-import-poll", SalaryImportPollController)
application.register("salary-indicators-pagination", SalaryIndicatorsPaginationController)
application.register("salary-coverage-modal", SalaryCoverageModalController)
application.register("scraper-logs-modal", ScraperLogsModalController)
application.register("shared-secret-form", SharedSecretFormController)
application.register("sidebar-collapse", SidebarCollapseController)
application.register("strategic-customer-details", StrategicCustomerDetailsController)
application.register("strategic-customer-filters", StrategicCustomerFiltersController)
application.register("strategic-customer-metrics-table", StrategicCustomerMetricsTableController)
application.register("strategic-customer-target-total", StrategicCustomerTargetTotalController)
application.register("toggle", ToggleController)
application.register("payload-modal", PayloadModalController)
application.register("process-log-modal", ProcessLogModalController)
application.register("error-toggle", ErrorToggleController)

export { application }
